import type { NodeDefinition } from '../types';

export const mathAddNode: NodeDefinition = {
  type: 'math.add',
  category: 'Math',
  label: 'Math Add',
  description: 'Calculates the sum of two numbers (A + B)',
  inputs: [
    { id: 'a', name: 'A', type: 'number', defaultValue: 0 },
    { id: 'b', name: 'B', type: 'number' }, // When unconnected, uses params.defaultB
  ],
  outputs: [
    { id: 'result', name: 'Result', type: 'number' },
  ],
  params: [
    { id: 'defaultB', name: 'Value B', type: 'number', defaultValue: 1.0 },
  ],
  processor: (inputs, params) => {
    const a = Number(inputs.a ?? 0);
    const b = Number(inputs.b ?? params.defaultB ?? 0);
    return {
      result: (isNaN(a) ? 0 : a) + (isNaN(b) ? 0 : b),
    };
  },
};
